"use client";

import { Phone, MapPin, Instagram, Facebook } from "lucide-react";
import { useTranslations } from "next-intl";

const GOOGLE_MAPS_EMBED =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4855.75500091777!2d18.0758075!3d42.659590699999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x134c756c62b6ec3d%3A0xc72b267de58c4746!2ssaiyan%20gym%20FITT!5e1!3m2!1sen!2shr!4v1784757802138!5m2!1sen!2shr";

const GOOGLE_MAPS_LINK =
  "https://maps.app.goo.gl/QrQYH2Dy8oi85iCf7";

export default function ContactSection() {
  const t = useTranslations("Contact");

  return (
    <section
      id="kontakt"
      className="bg-white px-4 py-16 sm:px-8 lg:px-10"
    >
      <div className="mx-auto max-w-6xl">
        {/* Heading */}
        <h2           className="mb-8 text-4xl font-bold tracking-tight text-[#18181b] sm:text-5xl">
          {t("heading")}
        </h2>

        {/* Two-column layout */}
        <div className="flex flex-col gap-6 lg:flex-row lg:items-stretch">
          {/* Left — contact card */}
          <div className="w-full rounded-3xl bg-[#F9FAFB] p-8 lg:w-[42%]">
            {/* Phone */}
            <div className="mb-8">
              <p className="mb-1 text-base font-semibold text-[#18181b]">
                {t("callTitle")}
              </p>
              <p className="mb-4 text-sm text-[#71717a]">
                {t("callHours")}
              </p>
              <a
                href="tel:+385916022843"
                className="inline-flex items-center gap-2 text-sm font-medium text-[#18181b] underline underline-offset-4 hover:opacity-70 transition-opacity"
              >
                <Phone className="h-4 w-4 shrink-0 text-[#71717a]" />
                +385 91 602 2843
              </a>
            </div>

            {/* Divider */}
            <div className="mb-8 h-px bg-[#E4E4E7]" />

            {/* Address */}
            <div className="mb-8">
              <p className="mb-1 text-base font-semibold text-[#18181b]">
                {t("visitTitle")}
              </p>
              <p className="text-sm text-[#71717a]">{t("visitHours1")}</p>
              <p className="mb-4 text-sm text-[#71717a]">{t("visitHours2")}</p>
              <a
                href={GOOGLE_MAPS_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm font-medium text-[#18181b] underline underline-offset-4 hover:opacity-70 transition-opacity"
              >
                <MapPin className="h-4 w-4 shrink-0 text-[#71717a]" />
                Ćira Carića 1, Dubrovnik
              </a>
            </div>

            {/* Divider */}
            <div className="mb-8 h-px bg-[#E4E4E7]" />

            {/* Social */}
            <div>
              <p className="mb-4 text-base font-semibold text-[#18181b]">
                {t("socialTitle")}
              </p>
              <div className="flex items-center gap-3">
                <a
                  href="https://www.instagram.com/saiyan_gym_fitt/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t("instagramAria")}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-[#E4E4E7] bg-white text-[#18181b] transition-colors hover:bg-[#f4f4f5]"
                >
                  <Instagram className="h-5 w-5" />
                </a>
                <a
                  href="http://facebook.com/p/Saiyan-GYM-FITT-100092144478181"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t("facebookAria")}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-[#E4E4E7] bg-white text-[#18181b] transition-colors hover:bg-[#f4f4f5]"
                >
                  <Facebook className="h-5 w-5" />
                </a>
              </div>
            </div>
          </div>

          {/* Right — map */}
          <div className="w-full overflow-hidden rounded-3xl lg:w-[58%]">
            <iframe
              src={GOOGLE_MAPS_EMBED}
              title={t("mapTitle")}
              width="100%"
              height="100%"
              className="min-h-[360px] w-full border-0 lg:min-h-0 lg:h-full"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
